import {translate} from "vue-gettext";

const {pgettext: $pgettext} = translate;

export default {
    ACCEPTED: 'ACCEPTED',
    PENDING: 'PENDING',
    DISABLED: 'DISABLED',

    // Map backend values to internal values
    normalize(status) {
        const upperStatus = (status || '').toUpperCase()
        if (upperStatus === 'ACTIVE') return this.ACCEPTED
        return upperStatus
    },

    label(status, context = 'collaborators.status') {
        const labels = {
            [this.ACCEPTED]: $pgettext(context, 'Active'),
            [this.PENDING]: $pgettext(context, 'Pending'),
            [this.DISABLED]: $pgettext(context, 'Disabled')
        }
        return labels[status] || status
    },

    color(status) {
        const colors = {
            [this.ACCEPTED]: 'success',
            [this.PENDING]: 'warning',
            [this.DISABLED]: 'danger'
        }
        return colors[status] || 'secondary'
    },

    icon(status) {
        const icons = {
            [this.ACCEPTED]: 'cilCheckCircle',
            [this.PENDING]: 'cilClock',
            [this.DISABLED]: 'cilBan'
        }
        return icons[status] || 'cilCircle'
    },

    filterOptions(includeAny = true, context = 'collaborators.status.filter') {
        const options = []
        
        if (includeAny) {
            options.push({
                value: null,
                label: $pgettext(context, 'Any')
            })
        }

        // Only show Active and Pending in filter (not Disabled)
        options.push(
            {
                value: this.ACCEPTED,
                label: $pgettext(context, 'Active')
            },
            {
                value: this.PENDING,
                label: $pgettext(context, 'Pending')
            }
        )
        
        return options
    },

    values() {
        return [this.ACCEPTED, this.PENDING, this.DISABLED]
    },

    // Check if a status allows certain actions
    canResendInvitation(status) {
        return status === this.PENDING
    },

    canEnable(status) {
        return status === this.DISABLED
    },

    canDisable(status) {
        return status === this.ACCEPTED
    }
}